import React, { useState } from 'react';

import WizardFormFirstPage from './ResetPassword';
import WizardFormSecondPage from './VerifyEmail';
import WizardFormThirdPage from './VerifyPhoneNo';
import WizardFormFourthPage from './NewPassword';
// import WizardFormFifthPage from './CreateEntityFirstQues';
// import WizardFormSixthPage from './CreateEntitySecondQues';
// import WizardFormSeventhPage from './CreateEntityThirdQues';
// import WizardFormEighthPage from './Questionnaire_Screen1';
// import WizardFormNinePage from './Questionnaire_Screen2';
// import WizardFormTenPage from './Questionnaire_Screen3';
// import WizardFormElevenPage from './Questionnaire_Screen4';
// import WizardFormTwelvePage from './Questionnaire_Screen5';
// import WizardFormThirteenPage from './Questionnaire_Screen6';
// import WizardFormFourteenPage from './Questionnaire_Screen7';
// import WizardFormFifteenPage from './RegistrationConfirmationForm';

import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store'; // Import the RootState type
import { Field, reduxForm, InjectedFormProps } from 'redux-form';
interface Props {
    // Define your component's props here
}

const WizardResetAccount: React.FC<InjectedFormProps<FormData>> = (props: any) => {


    const { onSubmit, onPrev } = props;
    const dispatch = useDispatch();
    const page = useSelector((state: RootState) => state.resetPassword.wizardPageNumber);

    return (
        <div>
         
            {page === 1 && <WizardFormFirstPage />}
            {page === 2 && <WizardFormSecondPage />}
            {page === 3 && <WizardFormThirdPage />}
            {page === 4 && <WizardFormFourthPage />}
            {/*  {page === 5 && <WizardFormFifthPage />}
             {page === 6 && <WizardFormSixthPage />}
            {page === 7 && <WizardFormSeventhPage />}   */}


        </div>
    );
};


// Wrap the component with reduxForm

const WrappedWizardPersonalAccount = reduxForm<FormData, Props>({
    form: "resetWizard",
})(WizardResetAccount);

export default WrappedWizardPersonalAccount;
